import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "ユーザ一覧", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "特定プラン利用ユーザ自動選択", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.sort_btn_wrapper)
    }, [
      _createVNode(_component_el_button, {
        color: _ctx.BUTTON_COLOR,
        class: _normalizeClass(_ctx.$style.el_button),
        round: true,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.sortingTableVisible = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 並び替え表示 ")
        ]),
        _: 1
      }, 8, ["color", "class"])
    ], 2),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.state.sortingTableVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.sortingTableVisible) = $event)),
      title: "並び替え表示"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.state.userList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "name",
              label: "お名前",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              property: "email",
              label: "メールアドレス",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              property: "role",
              label: "種別",
              width: "80",
              sortable: ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.paymentHistoryVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.paymentHistoryVisible) = $event)),
        title: "購入履歴"
      }, {
        default: _withCtx(() => [
          (!_ctx.state.paymentHistories.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "購入履歴がありません。"))
            : (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: _ctx.state.paymentHistories
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    property: "created",
                    label: "受講日",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "受講プラン"
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "amount",
                    label: "金額",
                    width: "80"
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "deadline",
                    label: "有効期限",
                    width: "120"
                  })
                ]),
                _: 1
              }, 8, ["data"]))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.accessCodeConfigVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.accessCodeConfigVisible) = $event)),
        title: "アクセスコード選択"
      }, {
        default: _withCtx(() => [
          (!_ctx.selectedCount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "アクセスコードを送るユーザを選んでください。"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_row, {
                  class: _normalizeClass(_ctx.$style.el_row)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.state.selectedAccessCode,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.selectedAccessCode) = $event)),
                          class: "m-2",
                          placeholder: "アクセスコードを選択",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.accessCodeList, (accessCode) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: accessCode.id,
                                label: `${accessCode.accessCode} (残り${accessCode.remainingNumber})`,
                                value: accessCode.accessCode
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          onClick: _ctx.callApiOfSendEmailWithAccessCode,
                          color: _ctx.BUTTON_COLOR,
                          class: _normalizeClass(_ctx.$style.el_button),
                          disabled: !_ctx.isEnoughAccessCodeBySelectedCount
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" アクセスコードを送信 ")
                          ]),
                          _: 1
                        }, 8, ["onClick", "color", "class", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 件名："),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.state.accessCodeMailTitle,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.accessCodeMailTitle) = $event)),
                      placeholder: "件名"
                    }, null, 8, ["modelValue"]),
                    _hoisted_4,
                    _createTextVNode(" 本文："),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.state.accessCodeMailBody,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.accessCodeMailBody) = $event)),
                      autosize: "",
                      type: "textarea",
                      placeholder: "本文"
                    }, null, 8, ["modelValue"]),
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("p", null, [
                      _createTextVNode(" 任意の文章でクーポン送信メールを送信する場合は送信ボタンを押す前に↑の入力欄に文章を入力してください。 "),
                      _hoisted_9,
                      _createElementVNode("i", null, _toDisplayString(_ctx.ACCESS_CODE_REPLACE_TEXT), 1),
                      _createTextVNode(" と本文に書き込むことで "),
                      _createElementVNode("i", null, _toDisplayString(_ctx.ACCESS_CODE_REPLACE_TEXT), 1),
                      _createTextVNode(" がアクセスコード(英数字)へ置換されて送信されます。 ")
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.state.selectedAccessCode && !_ctx.isEnoughAccessCodeBySelectedCount)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      title: "選択したアクセスコードの残数が選択した人数に対して不足してます。",
                      type: "error",
                      center: "",
                      "show-icon": "",
                      closable: false
                    }))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.userList, (user) => {
        return (_openBlock(), _createBlock(_component_el_row, {
          key: Number(user.id),
          class: _normalizeClass(_ctx.$style.user_list)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.name), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.state.selectedUserFlagList[Number(user.id)],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.state.selectedUserFlagList[Number(user.id)]) = $event),
                  size: "large"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.email), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  color: _ctx.BUTTON_COLOR,
                  class: _normalizeClass(_ctx.$style.el_button),
                  round: true,
                  onClick: ($event: any) => (_ctx.showPaymentHistory(user))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 購入履歴 ")
                  ]),
                  _: 2
                }, 1032, ["color", "class", "onClick"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.roleToJa(user.role || '')), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  color: _ctx.BUTTON_COLOR,
                  class: _normalizeClass(_ctx.$style.el_button),
                  round: true,
                  onClick: ($event: any) => (_ctx.changeRole(user))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 権限変更 ")
                  ]),
                  _: 2
                }, 1032, ["color", "class", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128)),
      _createVNode(_component_el_button, {
        color: _ctx.BUTTON_COLOR,
        class: _normalizeClass(_ctx.$style.el_button),
        round: true,
        onClick: _ctx.fetchAccessCodesAndShowConfig
      }, {
        default: _withCtx(() => [
          _createTextVNode(" アクセスコードを選び" + _toDisplayString(_ctx.selectedCount) + "人へアクセスコードを送信する（選択ダイアログを開きます） ", 1)
        ]),
        _: 1
      }, 8, ["color", "class", "onClick"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.filter_by_plan_area)
    }, [
      _hoisted_10,
      _hoisted_11,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.el_row)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.state.selectedPlanId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.selectedPlanId) = $event)),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.countOfCheckedUsers = 0)),
                class: "m-2",
                placeholder: "プランを選択",
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.stripePlanList, (plan) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: plan.id,
                      label: `${plan.using ? '' : '[停止] '}${plan.title}`,
                      value: plan.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _ctx.selectUsersByPlan,
                color: _ctx.BUTTON_COLOR,
                class: _normalizeClass(_ctx.$style.el_button),
                round: true,
                disabled: !_ctx.state.selectedPlanId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 自動選択 ")
                ]),
                _: 1
              }, 8, ["onClick", "color", "class", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_12,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.el_row)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createTextVNode(" 自動選択状況： ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_progress, {
                percentage: (_ctx.state.countOfCheckedUsers / _ctx.state.userList.length) * 100
              }, null, 8, ["percentage"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ], 2)
  ]))
}